import { z } from 'zod';
import { BaseEntitySchema, TimestampSchema } from './common';
import { ImageId, RoundId, SessionId } from './ids';

export const RoundSchema = BaseEntitySchema.extend({
  id: RoundId,
  sessionId: SessionId,
  number: z.number().int().positive(),
  name: z.string().min(1).max(100).optional(),
  scores: z.record(z.string(), z.number()), // playerId/teamId → score
  notes: z.string().max(1000).optional(),
  tags: z.array(z.string().min(1).max(50)).optional(),
  imageIds: z.array(ImageId).default([]),
  completedAt: TimestampSchema.optional(),
});
export type Round = z.infer<typeof RoundSchema>;
